// PrivacyPolicy.jsx
import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { Link, useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const containerStyles = {
    marginLeft: '40px',
    marginRight: '20px',
  };

  const headingStyles = {
    color: 'yellow',
    marginTop: '20px',
  };

  const textStyles = {
    color: 'white',
  };

  return (
    <div className='bg-black'>
      <div className='min-h-[50vh] flex flex-col justify-center items-center bg-black p-8 rounded-lg shadow-lg'>
        <div className="border-b border-blue-400">
          <h1 className="ml-2 cursor-pointer text-yellow-200 mb-2">
            <Link 
              to="/" 
              className="text-yellow-300 uppercase text-m lg:text-xl space-x-2 mt-4" 
            >
              Think5Whys
            </Link>
          </h1>
        </div>          
        <div className='min-h-[70vh] bg-black border border-gray-400 p-6 rounded-lg shadow-lg max-w-3xl mt-2'>
          <p className='text-yellow-200 text-xl lg:text-2xl mb-4'>
            Refund and Cancellation Policy
          </p>
          <p className='text-white text-lg mb-4'>
            Thank you for your interest in our digital products and services.
          </p>
          <p className='text-white text-lg mb-4'>
            Please note that all sales are final, and we do not offer refunds or cancellations under normal circumstances, as we provide non-tangible digital goods and services.
          </p>
          <p className='text-white text-lg'>
            If you experience any issues with your purchase or service, please contact our support team, and we will be happy to assist you.
          </p>
        </div>
    </div>
    <footer className="bg-black border-t border-blue-800 text-white py-4 mt-5 lg:mt-2">
        <div className="mx-auto px-3 flex flex-col items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">
            © {new Date().getFullYear()} Think5Whys Global DeepTech Solutions Private Limited.
          </div>
          <div className="flex flex-row gap-2 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-200">About Us</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-200">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-200">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-200">Contact Us</Link>
            <Link to="/refund-cancellation-policy" className="text-white mx-2 hover:text-yellow-200">Refund & Cancellation Policy </Link>

          </div>
          <div className='text-center text-xs mb-2'>
            <p className='text-xs text-gray-500'>Address: B-1402, Riviera, Casa-Bella, Palava, Kalyan-Shil Road, Dombivali (East), Thane , Mumbai Metropolitan Region, Maharashtra, India, Postal Code: 421204</p>
          </div>               
        </div>
      </footer>         
    </div>
  );
};

export default PrivacyPolicy;
